<template>
  <div class="px-1 py-2 bg-white">
    <div class="mb-1">
      <label class="mb-0"><small>Assunto do Problema:</small></label>
      <select v-model="form.subject" class="form-control form-control-sm custom-select custom-select-sm">
        <option value="Financeiro">Financeiro</option>
        <option value="Suporte a ferramenta">Suporte a ferramenta</option>
        <option value="Outras dúvidas">Outras dúvidas</option>
      </select>
    </div>

    <div>
      <label class="mb-0"><small>Descreva o Problema:</small></label>
      <textarea class="form-control form-control-sm" rows="9" v-model="form.text"></textarea>
    </div>

    <button class="btn btn-sm btn-success w-100 mt-1" @click="openSupport">
      Enviar
    </button>

    <div class="w-100 mt-1">
      <p class="mb-0"><small>Email: <b><i>suporte@akdemica.com.br</i></b></small></p>
    </div>
  </div>
</template>

<script>
import { Form } from 'vform'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      form: new Form({
        subject: '',
        text: ''
      })
    }
  },
  methods: {
    openSupport: function () {
      this.form.post('/student/open/support')
        .then( res => {
          this.form.subject = ''
          this.form.text = ''
          this.$emit("success")
          Swal.fire({
            icon: 'success',
            title: 'Seu email foi enviado',
            text: 'Nossa equipe entrara em contato em breve!'
          })
        })
        .catch( err => {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: 'Erro ao enviar o Email, tente novamente mais tarde'
          })
        })
    }
  }
}
</script>

<style>

</style>
